import React from "react";
import "./Footer.scss";
 
export default function Footer() {
  return (
    <footer className="ap-footer" datatest-id="footer">
      <div className="ap-footer__content" datatest-id="footer-content">
        {/* Instagram */}
        <a href="https://www.instagram.com/accesspointprogram/#" datatest-id="instagram-link"
        target="_blank"
        rel="noopener noreferrer">
          <img
            src={process.env.PUBLIC_URL + "/instagramTransparent.png"}
            alt="Instagram"
            className="ap-footer__icon"
            datatest-id="instagram-icon"
          />
        </a>
 
        {/* Facebook */}
        <a href="https://www.facebook.com/AccessPointProgram" data-testid="facebook-link"
        target="_blank"
        rel="noopener noreferrer">
          <img
            src={process.env.PUBLIC_URL + "/facebookTransparent.png"}
            alt="Facebook"
            className="ap-footer__icon"
            datatest-id="facebook-icon"
          />
          
        </a>
 
        {/* Access Point logo (LinkedIn company page) */}
        <a href="https://www.accesspointprogram.org/" data-testid="access-point-link"
        target="_blank"
        rel="noopener noreferrer">
          <img
            src={process.env.PUBLIC_URL + "/APBackgroundRemoved.jpg"}
            alt="Access Point"
            className="ap-footer__logo"
            datatest-id="access-point-logo"
          />
        </a>
 
        {/* LinkedIn icon */}
        <a href="https://www.linkedin.com/company/accesspointprogram/posts/" data-testid="linkedin-link"
        target="_blank"
        rel="noopener noreferrer">
          <img
            src={process.env.PUBLIC_URL + "/linkedinTransparent.png"}
            alt="LinkedIn"
            className="ap-footer__icon"
            datatest-id="linkedin-icon"
          />
        </a>
 
        {/* X / Twitter */}
        <a href="https://x.com/AccessPointIT" data-testid="twitter-link"
        target="_blank"
        rel="noopener noreferrer">
          <img
            src={process.env.PUBLIC_URL + "/XTransparent.png"}
            alt="X (Twitter)"
            className="ap-footer__icon"
            datatest-id="twitter-icon"
          />
        </a>
      </div>
    </footer>
  );
}
